import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';

const GetTotalDischargesByTypeResponseDtoSchema =
  PagePaginationResponseDtoSchema(
    z.object({
      currentValue: z.number(),
      marketMedian: z.number().nullable(),
      reason: z.string(),
    })
  );

export type GetTotalDischargesByTypeRequestDto = PagePaginationRequestDto<{
  facilityId: number;
  from: string;
  to: string;
  comparisonSet: 'INTERNAL' | 'COMP';
  page: number;
}>;
export type GetTotalDischargesByTypeResponseDto = z.infer<
  typeof GetTotalDischargesByTypeResponseDtoSchema
>;

export const getTotalDischargesByType = async (
  params: GetTotalDischargesByTypeRequestDto,
  config?: AxiosRequestConfig<GetTotalDischargesByTypeRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/discharges-by-type`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetTotalDischargesByTypeResponseDtoSchema));
};
